var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/hierarchy-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hierarchy-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.58301 13.8161V7.39944",
    stroke: "#6F767E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.81217 20.2328C6.45752 20.2328 7.79134 18.899 7.79134 17.2536C7.79134 15.6083 6.45752 14.2744 4.81217 14.2744C3.16683 14.2744 1.83301 15.6083 1.83301 17.2536C1.83301 18.899 3.16683 20.2328 4.81217 20.2328Z",
    stroke: "#6F767E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.58301 7.39944C6.10179 7.39944 7.33301 6.16823 7.33301 4.64944C7.33301 3.13066 6.10179 1.89944 4.58301 1.89944C3.06422 1.89944 1.83301 3.13066 1.83301 4.64944C1.83301 6.16823 3.06422 7.39944 4.58301 7.39944Z",
    stroke: "#6F767E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.417 7.39944C18.9358 7.39944 20.167 6.16823 20.167 4.64944C20.167 3.13066 18.9358 1.89944 17.417 1.89944C15.8982 1.89944 14.667 3.13066 14.667 4.64944C14.667 6.16823 15.8982 7.39944 17.417 7.39944Z",
    stroke: "#6F767E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.70215 13.8161C5.11465 12.2119 6.58131 11.0203 8.31381 11.0294L11.458 11.0386C13.8596 11.0478 15.9038 9.50776 16.6555 7.36276",
    stroke: "#6F767E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKs);
export default __webpack_public_path__ + "static/media/ks.4e44854f62947256f2e60981bf9f428b.svg";
export { ForwardRef as ReactComponent };